import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledFarmEdit = styled('div')`
  .ant-input {
    border-radius: 3px;
  }

  .infrastructures-buttons {
    display: flex;
    gap: 10px;
  }

  .sync-farm-button {
    margin-left: 10px;
  }
`;

export const StyledContractCards = styled('div')`
  display: flex;
  gap: 21px;

  .contract-card {
    width: 445px;
    border: 1px solid ${(props) => props.theme.border};
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .title {
      font-size: 20px;
      color: ${(props) => props.theme.colorPrimary};
      margin-bottom: 12px;
    }

    .ant-form-item {
      margin: 0;
    }

    .bank-input {
      display: flex;
      flex-grow: 1;

      .ant-form-item-row {
        display: flex;
        flex-grow: 1;

        .ant-form-item-control-input-content {
          max-width: 100%;
        }
      }
    }

    .contract-button-margin {
      margin-bottom: 40px;
    }

    .contract-buttons {
      display: flex;
      flex-direction: column;
      padding-top: 35px;
    }

    .contract-content {
      color: ${(props) => props.theme.colorPrimary};
      min-height: 35px;

      .content-block {
        margin-bottom: 12px;
      }

      .content-entry {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    flex-direction: column;

    .contract-card {
      width: 100%;

      .contract-content {
        .content-entry {
          font-size: 1rem;
        }
      }

      .title {
        font-size: 1.25rem;
      }
    }
  }
`;

export const StyledBusinessTab = styled('div')`
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontText};

  .ant-table-wrapper {
    margin: 20px 0 0 0;
    .ant-table-thead {
      height: 75px;
      .ant-table-cell {
        padding: 0 0 0 25px;
        font-weight: 400;
        color: ${(props) => props.theme.black};
      }
    }

    .ant-table-tbody {
      .ant-table-cell {
        color: ${(props) => props.theme.colorText};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 331px;
        padding: 16px 24px;
        height: 72px;

        .ant-btn {
          padding: 5px 10px 5px 10px;
          border-radius: 3px;
          border: 1px solid ${(props) => props.theme.colorText};
          color: ${(props) => props.theme.colorButtonText};
          height: 26px;
          .ant-btn-icon {
            div {
              display: flex;
            }
          }
        }
      }

      .ant-table-cell::before {
        display: none;
        color: red;
      }

      .ant-table-cell.centered-column {
        text-align: center;
      }
    }
    .ant-table-cell::before {
      display: none;
      color: red;
    }

    .ant-table-cell.centered-column {
      text-align: center;
    }
  }

  .open-hours {
    text-wrap: nowrap;
  }

  .new-btn {
    width: fit-content !important;
    font-family: ${(props) => props.theme.fontText};
    border-radius: 3px;
  }

  .input-filelist {
    display: flex;
    gap: 100px;
  }

  .input-filelist.column {
    flex-direction: column;
    gap: 0;

    .ant-form-item-control-input {
      width: 250px;
    }
  }

  .double-input-date {
    display: flex;
    gap: 20px;
  }

  .yt {
    padding-bottom: 50px;
    max-width: 430px;
    label {
      bottom: -10px;
    }
  }

  .gallery,
  .video {
    padding-top: 100px;
  }

  h3 {
    margin-bottom: 5px;
  }

  .upload-content {
    display: flex;
  }

  .content {
    min-height: 100%;

    .address-finder-without-modal {
      .ant-form-item-label {
        padding-bottom: 0;
      }

      .ant-form-item-control-input {
        min-width: 407px;

        .form-control {
          width: 100%;
          height: 40px;
        }
      }
    }

    .section {
      max-width: 844px;
      min-height: 200px;

      .ant-input.ant-input-disabled {
        color: ${(props) => props.theme.colorPrimary} !important;
      }

      .double-column-checkbox {
        .ant-checkbox-group {
          display: grid;
          grid-template-columns: 50% 50%;
          gap: 0.5em;
          column-gap: 25%;
          .ant-checkbox-wrapper {
            .ant-checkbox {
              padding-right: 5px;

              .ant-checkbox-inner:after {
                transform: rotate(45deg) scale(1) translate(-70%, -50%);
              }
            }
            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .double-column-checkbox-two-sixteen {
        .ant-checkbox-group {
          display: grid;
          grid-template-columns: 50% 50%;
          gap: 0.5em;
          column-gap: 5%;
          .ant-checkbox-wrapper {
            .ant-checkbox {
              padding-right: 5px;
            }
            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    textarea {
      height: 80px;
      border-radius: 5px;
      resize: none;
    }

    .text-area {
      label {
        position: relative;
        top: 8px;
      }

      .ant-input-data-count {
        position: relative;
        right: 5px;
      }

      .ant-input {
        height: 150px;
      }
      .ant-input-suffix {
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .bottom-border-wrapper {
      position: relative;
      width: 100vw;

      .bottom-border {
        border-bottom: 1px solid ${(props) => props.theme.borderInput};
        padding-top: 20px;
        width: 100%;
      }
    }

    .label-fix {
      .ant-col {
        padding-bottom: 0;
      }
    }

    .ant-form-item {
      margin-bottom: 10px;
    }
  }

  .double-checkbox {
    display: flex;
    gap: 133px;
    .ant-form-item {
      margin-bottom: 10px;
      .ant-checkbox-inner:after {
        transform: rotate(45deg) scale(1) translate(-65%, -58%);
      }
    }
  }

  .double-input {
    display: flex;
    justify-content: space-between;

    .ant-form-item-control-input {
      min-width: 407px;
    }
  }

  .double-input.wrap {
    flex-wrap: wrap;
  }

  .location-issue {
    max-width: 838px;
    margin-bottom: 16px;
  }

  .add-pvd-number-row {
    margin-top: 8px;
    max-width: 407px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .content {
      .section {
        .image-upload {
          .ant-upload-drag {
            width: 100%;
          }

          .ant-upload {
            width: 100%;
            .ant-upload-drag-container {
              width: 100%;
            }
          }

          .custom-upload-list-image-container {
            justify-content: space-between;
          }
        }

        .address-finder-without-modal {
          .ant-form-item-control-input {
            min-width: 100%;
            width: 100%;
          }
        }

        .ant-input {
          background-color: ${(props) => props.theme.white};
          border-radius: 3px;
        }
        .ant-checkbox-wrapper {
          span {
            font-size: 0.875rem;
          }
        }
        .ant-input-affix-wrapper {
          border-radius: 3px;
        }
        .ant-form-item-control-input {
          min-width: 100%;
        }

        .double-input {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
        }
        .double-checkbox {
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          gap: 0;
        }
        .ant-checkbox-group {
          grid-template-columns: 100% !important;
          gap: 10px !important;
        }
      }
    }
    .new-btn {
      width: 100% !important;
      margin-bottom: 20px;
    }
    .gallery,
    .video {
      padding-top: 16px;
    }

    .image-upload {
      .ant-upload-drag {
        width: 100%;
        .ant-upload-btn {
          width: 100%;
          .ant-upload-drag-container {
            width: 100%;
          }
        }
      }
    }
  }
`;

export const StyledBusinessInformation = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const StyledQualityMarksTable = styled('div')`
  .ant-table-content {
    min-height: 60vh;
  }

  table {
    table-layout: fixed;
  }

  .bold {
    font-weight: bold;
  }

  .product-selects-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .add-button-wrapper {
    align-self: flex-start;
    margin-top: 4px;
  }

  .select-with-remove {
    display: flex;
    align-items: center;
    gap: 8px;

    .ant-form-item,
    .ant-select {
      flex: 1;
      margin: 0;
    }
  }

  .remove-button-wrapper {
    flex-shrink: 0;
  }
`;
